export const Class = {
   classId: 'class_id',
   className: 'class_name',
};
